"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleepAsync = void 0;
function sleepAsync(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}
exports.sleepAsync = sleepAsync;
